import React from "react";
import { ChangeEvent, Fragment } from "react";
import { Prompt } from "react-router";
import { RouteComponentPropsHistory } from "../../types";
// import { Link } from "react-router-dom";

import { DateTime } from "luxon";

// import DelayInput from "../DelayInput";
import HasRight from "../HasRight";

import { V2 } from "../../Api";
import { formatDateLocalNumeric, formatDateTimeLocalNumeric, formatName } from "../../Utilities";
import withTitle from "../withTitle";


interface IMetricsBonusCalculateViewState {
    changedFields: string[];
    hasChanged: boolean;
    isCalculating: boolean | string;
    isLockedOut: boolean;
    isSubmitting: boolean | string;

    conversionMethod: string;
    group: string;
    month: string;

    result: any[];
    warnings: any[];

    [name: string]: any;
}

class MetricsBonusCalculateView extends React.Component<RouteComponentPropsHistory<any, any>, IMetricsBonusCalculateViewState> {
    constructor(props: Readonly<RouteComponentPropsHistory<any, any>>) {
        super(props);

        const today = new Date();

        const state: IMetricsBonusCalculateViewState = {
            changedFields: [],
            hasChanged: false,
            isCalculating: false,
            isLockedOut: true,
            isSubmitting: false,

            conversionMethod: "1",
            group: (props.location.state && props.location.state.group) || "0",
            month: (props.location.state && props.location.state.month) || `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}`,

            result: [],
            warnings: [],
        };

        state.isLockedOut = this.determineLockOut(state.month);

        this.state = state;

        this.formInputChanged = this.formInputChanged.bind(this);
        this.calculateBonuses = this.calculateBonuses.bind(this);
        this.cancelPage = this.cancelPage.bind(this);
        this.saveBonuses = this.saveBonuses.bind(this);
    }

    public componentDidUpdate(prevProps: Readonly<RouteComponentPropsHistory<any, any>>, prevState: Readonly<IMetricsBonusCalculateViewState>) {
        if (prevState.month !== this.state.month) {
            this.setState({
                isLockedOut: this.determineLockOut()
            });
        }
        if (prevState.group !== this.state.group) {
            this.setState({
                result: [],
                warnings: [],
            });
        }
    }

    public render() {
        return (
            <div className="viewer-root">
                <Prompt when={!!this.state.result && this.state.result.length > 0} message="Your changes will not be saved if you continue." />
                <div className="column-root input-form">
                    <section className="info-block">
                        <header>
                            <h2>Bonus Information</h2>
                        </header>

                        <section>
                            <div className="input-form-group">
                                <label htmlFor="frm-group" className="required">Group</label>
                                <select id="frm-group" name="group" value={this.state.group} onChange={this.formInputChanged} >
                                    <HasRight right="metrics:bonus:m:calc">
                                        <option value="0">HF Team</option>
                                        <option value="5">Telemarketing</option>
                                        <option value="6">Surgical Consultants</option>
                                    </HasRight>
                                    <HasRight right="metrics:bonus:n:calc">
                                        <option value="1">NPs</option>
                                    </HasRight>
                                    <HasRight right="metrics:bonus:d:calc">
                                        <option value="2">Doctors</option>
                                    </HasRight>
                                    <HasRight right="metrics:bonus:so:calc">
                                        <option value="3">Surgical Outcomes</option>
                                    </HasRight>
                                    <HasRight right="metrics:bonus:mm:calc">
                                        <option value="4">Marketing Manager</option>
                                    </HasRight>
                                </select>
                            </div>
                            <div className="input-form-group">
                                <label htmlFor="frm-month" className="required">Month</label>
                                <input type="month" id="frm-month" name="month" value={this.state.month} onChange={this.formInputChanged} />
                            </div>
                        </section>
                    </section>
                    <section className="info-block">
                        <header>
                            <h2>Additional Parameters</h2>
                        </header>

                        <em>No additional properties are required</em>
                    </section>
                </div>
                &nbsp;
                <div className="action-panel-dialog">
                    <button className="button push-right" onClick={this.calculateBonuses} disabled={this.state.isCalculating === true}>Calculate </button>
                </div>
                <h3>Results</h3>
                {
                    !this.state.result || this.state.result.length < 1
                        ? this.state.isCalculating === true
                            ? <span className="spinner-outer-text">Calculating... <span className="spinner lds-dual-ring" /></span>
                            : typeof this.state.isCalculating === "string"
                                ? <span className="error-text">{this.state.isCalculating}</span>
                                : <em>Calculation not yet performed or no bonuses available.<br />Check your settings and push the <b>Calculate</b> button above.</em>
                        : <table className="table-vertical">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th className="col-smallest th-font-tiny">Cases</th>
                                    <th className="col-smallest th-font-tiny">Rate</th>
                                    <th className="col-smallest th-font-tiny">Unit</th>
                                    <th className="col-smallest col-center th-font-tiny">Amount</th>
                                    <th className="col-smallest">Total</th>
                                </tr>
                            </thead>
                            <thead className="table-vertical-head-small">
                                <tr>
                                    <th>Results</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.result.map(a => (
                                        <Fragment key={a.employeeId}>
                                            <tr>
                                                <th colSpan={10}>{formatName(a.employee.name)}</th>
                                            </tr>
                                            {a.items.map((b: any) => this.renderSummaryLine(b))}
                                            {
                                                a.group === 2
                                                    ? ""
                                                    : <tr>
                                                        <td className="col-right col-bold inline" colSpan={4}>Grand total</td>
                                                        <td className="col-right col-bold inline" />
                                                        <td className="col-right col-bold inline">{this.formatAmount(a.total, 1)}</td>
                                                    </tr>
                                            }
                                        </Fragment>
                                    ))
                                }
                            </tbody>
                        </table>
                }
                &nbsp;
                {
                    this.state.isCalculating === false && this.state.warnings && this.state.warnings.length > 0
                        ? <section className="info-block">
                            <header>
                                <h3>Warnings &mdash; {this.state.warnings.length}</h3>
                            </header>
                            <p>
                                The following surgeries have incorrect, odd, or data missing that could impact the bonus calculation.<br />
                                Correct them as necessary, then run the calculation again.
                            </p>
                            <ul className="list-simple">
                                {
                                    this.state.warnings.map(a => (
                                        <li>
                                            <div><b>{a.time ? formatDateTimeLocalNumeric(DateTime.fromISO(`${a.date.substring(0, 10)}T${a.time}`, { zone: "America/New_York" })) : formatDateLocalNumeric(Date.fromLocalDate(a.date.substring(0, 10)))} &mdash; {formatName(a.primarySurgeon.name)}</b></div>
                                            <small>ID: {a.id}</small>
                                            {a.primarySurgery && <dl>
                                                <dt>{a.primarySurgery.shortName} ({a.primarySurgery.cpt || "No CPT"})</dt>
                                            </dl>}
                                            {(a.marketerId || a.bonusId) && <dl>
                                                <dt>{a.marketer ? formatName(a.marketer.name) : "No marketer assigned"}</dt>
                                                <dt>{a.bonus ? `Bonus: ${a.bonus.name}` : "No bonus assigned"}</dt>
                                            </dl>}
                                            {a.providerId && <dl>
                                                <dt>{a.provider ? formatName(a.provider.name) : "No provider assigned"}</dt>
                                            </dl>}
                                            {
                                                a.primarySurgeryOptions && a.primarySurgeryOptions.some((b: any) => b.wrvu === null)
                                                    ? <dl>
                                                        {
                                                            a.primarySurgery.name === a.primarySurgery.shortName
                                                                ? <dt>{a.primarySurgery.name}</dt>
                                                                : <dt>{a.primarySurgery.shortName} &mdash; {a.primarySurgery.name}</dt>
                                                        }
                                                        {
                                                            a.primarySurgeryOptions.filter((b: any) => b.wrvu === null).map((b: any) => (
                                                                <dd><b>{b.id}</b></dd>
                                                            ))
                                                        }
                                                    </dl>
                                                    : ""
                                            }
                                            {
                                                a.additionalSurgeries && a.additionalSurgeries.filter((b: any) => b.options.some((c: any) => c.wrvu === null)).map((b: any) => (
                                                    <dl>
                                                        {
                                                            b.surgery.name === b.surgery.shortName
                                                                ? <dt>{b.surgery.name}</dt>
                                                                : <dt>{b.surgery.shortName} &mdash; {b.surgery.name}</dt>
                                                        }
                                                        {
                                                            b.options.filter((c: any) => c.wrvu === null).map((c: any) => (
                                                                <dd><b>{c.id}</b></dd>
                                                            ))
                                                        }
                                                    </dl>
                                                ))
                                            }
                                        </li>
                                    ))
                                }
                            </ul>
                        </section>
                        : ""
                }
                &nbsp;
                {
                    this.state.isSubmitting === true
                        ? <div className="spinner lds-dual-ring" />
                        : typeof this.state.isSubmitting === "string"
                            ? <span className="error-text">{this.state.isSubmitting}</span>
                            : ""
                }
                <div className="action-panel-dialog">
                    <button className="button push-right btn-confirm" onClick={this.saveBonuses} disabled={!this.state.result || this.state.result.length < 1 || this.state.isLockedOut}>Save</button>
                    <button className="button btn-cancel" onClick={this.cancelPage}>Cancel</button>
                </div>
            </div>
        );
    }

    private formInputChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement> | ChangeEvent<HTMLSelectElement>, callback?: (state: Partial<IMetricsBonusCalculateViewState>) => void) {
        const name = e.currentTarget.name;
        const value = e.currentTarget.type === "checkbox" ? (e.currentTarget as HTMLInputElement).checked : e.currentTarget.value;

        this.setState(s => {
            if (!s.changedFields.some(a => a === name)) {
                s.changedFields.push(name);
            }

            const newState = {
                changedFields: s.changedFields,
                hasChanged: true,
                [name]: value
            }

            if (callback) {
                callback(newState);
            }

            return newState;
        });
    }

    private async calculateBonuses() {
        await this.doCalculation(false);
    }

    private cancelPage() {
        this.props.history.goBack();
    }

    private async saveBonuses() {
        const success = await this.doCalculation(true);

        if (success) {
            this.props.history.goBack();
        }
    }

    private async doCalculation(saveResults: boolean) {
        try {
            this.setState({
                isCalculating: true,
                result: [],
            });

            const data = {
                conversionMethod: this.state.conversionMethod,
                group: this.state.group,
                save: !!saveResults,
            };

            const result = await V2.post<any>(`bonus/month/${this.state.month}/calculate`, data);
            const sets: any[] = result ? result.bonusSets || result : [];
            const warnings: any[] = result ? (result.warnings || []) : [];
            if (sets) {
                sets.sort((a, b) => formatName(a.employee.name).localeCompare(formatName(b.employee.name)));
            }

            return new Promise((resolve, reject) => {
                this.setState({
                    result: sets,
                    warnings,

                    isCalculating: false,
                }, () => resolve(true));
            });
        }
        catch (e) {
            this.setState({
                isCalculating: e.message
            });

            return false;
        }
    }

    private determineLockOut(monthOverride?: string) {
        const today = new Date();
        const month = Date.fromLocalDate(monthOverride || this.state.month);

        const isLocked = month.getFullYear() >= today.getFullYear() && month.getMonth() >= today.getMonth();
        return isLocked;
    }

    private renderSummaryLine(a: any) {
        if (a.type === 0) {
            return <tr key={a.id}>
                <td>{a.name}</td>
                <td className="col-right-vt">{a.caseCount}</td>
                <td className="col-right-vt">{a.rate !== undefined ? this.formatAmount(a.rate, a.unit) : null}</td>
                <td className="col-center"><small>{this.unitToString(a.unit)}</small></td>
                <td className="col-right-vt">{this.formatAmount(a.value, a.unit)}</td>
                <td className="col-right-vt">{a.unit === 1 ? this.formatAmount(a.value, a.unit) : ""}</td>
            </tr>;
        }
        else if (a.type === 1) {
            return <tr key={a.id}>
                <td colSpan={4} className="col-right-vt"><b>{a.name}</b></td>
                <td className="col-right-vt">{this.formatAmount(a.value, a.unit)}</td>
                <td className="col-right-vt">{this.formatAmount(a.total, 1)}</td>
            </tr>;
        }
        else if (a.type === 2) {
            return <tr key={a.id}>
                <td>{a.name}</td>
                <td className="col-right-vt">{a.caseCount}</td>
                <td colSpan={4} />
            </tr>;
        }
    }

    private unitToString(unit: number) {
        switch (unit) {
            case 0: return "Points";
            case 1: return "USD";
            case 2: return "wRVU";
            default: return unit.toString();
        }
    }

    private formatAmount(amount: string | number, unit: number) {
        switch (unit) {
            case 0: return amount;
            case 1: return (+amount).toLocaleString(undefined, { style: "currency", currency: "USD" });
            default: return amount;
        }
    }
}

export default withTitle("Calculate Bonuses", MetricsBonusCalculateView);
